<template>
  <div>
            <Righticon  ref="righticon"></Righticon>
    <div class="fff">
      <div v-for="(itemw,indexw) in NameList" :key="indexw">
      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{$t("menu.testContent") }}</h3>
      </div>
      
      <el-row >
          <el-col :span="24"  >
              <div class="GuoJiYinDu">
                <p v-html="itemw.details"></p>
              </div>
          </el-col>
      </el-row>

        <el-row >
          <el-col :span="24" style="margin-top:20px" >
                <router-link to="/SurveyandQuotation">  <el-button size="mini"  round> {{$t("menu.consult") }}</el-button></router-link>
          <el-button size="mini" round  @click="childMethod">{{$t("menu.feedback") }}</el-button>
        </el-col>
      </el-row>

      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{$t("menu.precautions") }}</h3> 
      </div>

      <div class="GuoJiYinDu">
        <p v-html="itemw.remarks" style="white-space: pre-line;line-height:30px"> </p>
      </div>
    </div> 


<!-- 

      <div class="ServiceContent">
        <el-col :span="11">
          <h3>{{$t("menu.ServiceContent") }}</h3>
        </el-col>
        <el-col :span="6">
          <h3>{{$t("menu.testItem") }}</h3>
        </el-col>
      </div> 

      <div class="Properties" v-for="it in ProjectList" :key="it.details">
        <el-col :span="11">
          <div>{{ it.details }}</div>
        </el-col>
        <el-col :span="13">
          <div class="yindusyyi">{{ it.item }} </div>
        </el-col>
      </div>  -->


       
      <!--我们的优势  -->

      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{$t("menu.advantages") }}</h3>
      </div>


      <div
        class="ServiceContenter"
        v-for="(items, index3) in advantageList"
        :key="index3"
      >
        <el-col :span="24">
          <p>{{ items.details }}</p>
        </el-col>
      </div> 


      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{$t("menu.recommendation") }}</h3>
      </div>
      <!-- :autoplay="false"  -->
      <el-carousel height="360px" arrow="never" trigger="click">
              <el-carousel-item v-for="(item, index) in SelectList" :key="index">

          <el-row>
            <el-col :span="12" v-for="(item1, index1) in item" :key="index1">
              <!-- -->
                 <router-link  :to="{ path:item1.routePath,query:{ti:index1+1}}"> 
                      <div class="cenTuiJian" >
                        <div class="bse">{{ item1.title }}</div>

                        <span class="yindusy" v-html="item1.details"> </span>
                      </div>
               </router-link>
              <!---->
            </el-col>
            
          </el-row> 
         
        </el-carousel-item>
      </el-carousel>
    
    </div>
  </div>
</template>

<script>
// import bus from "@/assets/js/eventBus.js";


export default {
  name: "TensileTest",
  data() {
    return {
      // number: "2-1",
      // srcQiYe: require("@/assets/images/new/tianchong1.jpg"),
      SelectList: [],

      // ProjectList: [],
      // 优势
      advantageList: [],

      titley: "",
ti:"",
      // name: "",
      NameList:[]
    };
  },
  created: function () {
 let ti=this.$route.query.ti;
 this.ti=ti;

    if (this.$i18n.locale == "TC") {
      this.titley = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.titley = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.titley = "SC";
    }
     console.log(this.titley)
    // 相关推荐
    this.getSelect();
    // 我们的优势,
    this.getSelectRubber();
    // 根据名称查询
   this.getSelectName();
  },
  methods: {
      // 弹出模态框
      childMethod() {
            // console.log("我是子组件的方法，我在子组件中调用了父组件的方法");
            this.$refs.righticon.clickbtn();
          },

           // 相关推荐
    async getSelect() {
      const { data: res } = await this.$http.get("/Business/GetCatalogue", {
        params: { category: "plastic", languageType: this.titley }, 
      });

      if (res.code !== 200) return console.log("数据请求失败! ");
    

// console.log( res.data)
      this.SelectList = [];
      // 思路：
      // 1.4条数据为一组
      //  先知道能分多少组

      var length = res.data.length;
      var groupCount = (res.data.length / 4) + 1;
      var idx = 4 

      for(let i = 0,j=0; i < res.data.length && j < groupCount ; j++){//第一次执行，0<0不执行，第二种情况，0<1执行，并且要0<分组的数，
         // 
          var array = [];
          if(i < res.data.length){   //0<1   i++    //第二种情况，0不小于0，直接跳到break。
               array.push(res.data[i]);
          }
          i++;//i=1
           if(i < res.data.length){//1<2 i++  第二种情况，1<1不执行
               array.push(res.data[i]);
          } 
          i++;
           if(i < res.data.length){
               array.push(res.data[i]);
          }
          i++;
           if(i < res.data.length){
               array.push(res.data[i]);
          }
            i++; 
        console.log(array)
        if(array.length == 0) break;
           this.SelectList.push(array); 
      }

    },



// 我们的优势，检测项目
    async getSelectRubber() {
      const { data: res } = await this.$http.get(
        "/Business/GetAdvantage",
        {
            params: { languageType: this.titley },
        }
      );

      if (res.code !== 200) return console.log("数据请求失败! ");

      // this.ProjectList = res.data.project;
      // console.log(this.ProjectList)
      // 我们的优势
      this.advantageList = res.data;
    },

// 名称查询
   async getSelectName() {
// let ti=this.$route.query.ti;
// console.log(ti)
      const { data: res } = await this.$http.get(
        "/Business/GetItemInfo",
        {
          params: { sort: this.ti,category:"plastic", languageType: this.titley },
        }
        // 
      );

      if (res.code !== 200) return console.log("数据请求失败! ");

      this.NameList = res.data;
    console.log(this.NameList)
    },
  },
    watch: {
 // 方法1 //监听路由是否变化
  '$route' (to, from) {
   if(to.query.ti !== from.query.ti){
            this.ti = to.query.ti;
            this.getSelectName();//重新加载数据
        }
  }
}
};

</script>




<style lang="less" scoped>
.GuoJiYinDu>p{
  // background: #ffffff;
  margin: 0px;
}
.yindusyyi {
  font-size: 12px;
  /* padding: 20px 0px; */
  color: #666666;

}
/deep/.el-button--mini, .el-button--mini.is-round{
  margin-left:   20px;

}
/deep/ .el-carousel__indicator.is-active button {
  background: #333333;
}
/deep/ .el-carousel__button {
  /* border: 1px solid #333333; */
  width: 12px;
  height: 12px;
  border: 1px solid #333333;
  border-radius: 50%;
}
.Properties {
    margin: 0px 30px;
    padding: 15px 0px;
    display: inline-flex;
    align-items: center;
    width: 93%;
 border-bottom: 1px solid #eeeeee;
} 
.bse:hover,
.bse:focus {
  color: #1d2088;
}
.cenTuiJian {
  /* width: 414px; */
  /* height: 125px; */
  background: #f2f2f2;

  margin: 10px;
  font-size: 16px;
  /* padding-left: 20px; */
  padding: 50px 20px;

}

h3 {
  font-size: 20px;
}

.bse{
        overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:1;
    -webkit-box-orient: vertical;
}
.yindusy {
  font-size: 12px;
  /* padding: 20px 0px; */
  color: #666666;
          overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:1;
    -webkit-box-orient: vertical;
}
.GuoJiYinDu {
  line-height: 10px;
  font-size: 16px;
  color: #666666;
  margin-left: 20px;
}
.ServiceContent {
  /* width: 840px; */
  height: 64px;
  background: #1d2088;
  margin: 0px 20px;
  margin-top: 40px;
  padding: 0px 20px;
  color: #ffffff;
}
.ServiceContenter {
  /* width: 840px; */
  // height: 40px;
  background: #1d2088;
  margin: 10px 20px;

  font-size: 12px;
    display: flex;
    align-items: center;
    padding: 5px 10px;
  color: #ffffff;
}
.divider {
  background-color: #eeeeee;
}

.Xjiao {
  color: #1d2088;
  font-size: 20px;
}
.fff {
  background: #ffffff;
  /* padding: 0px 20px; */
  margin-bottom: 20px;
}
.img {
  width: 288px;
  height: 216px;
}
/deep/ a{
  color: #333333;
  text-decoration: none;
}
</style>

